import Box from '@mui/material/Box';
import { t } from 'i18next';

import { ROUTES } from '~router/routePaths';

import { StepCallout } from '../CompanyOnboardingPrimitives';
import StepSectionCard from './StepSectionCard';

const SECTIONS = [
  { link: ROUTES.settings.ratesManagement, sectionKey: 'freight_rates' },
  { link: ROUTES.settings.paymentTermsManagement, sectionKey: 'payment_terms' },
  { link: ROUTES.settings.taxRateScheduleManagement, sectionKey: 'tax_rate_schedules' },
  { link: ROUTES.settings.addOnCharges, sectionKey: 'add_ons' },
];

const COPY_PREFIX = 'company_onboarding.modules.freight_rates.work_area';

const FreightRatesStep = () => (
  <Box data-test-id="company-onboarding-freight-rates">
    <StepCallout
      body={t(`${COPY_PREFIX}.callout_body`)}
      title={t(`${COPY_PREFIX}.callout_title`)}
    />
    {SECTIONS.map(({ link, sectionKey }) => (
      <StepSectionCard
        copyKey={`${COPY_PREFIX}.sections.${sectionKey}`}
        key={sectionKey}
        link={link}
        testId={`company-onboarding-freight-rates-${sectionKey}`}
      />
    ))}
  </Box>
);

export default FreightRatesStep;
